module.exports = __webpack_public_path__ + "img/calhoun-sheriff-logo.7ebcbdb6.jpg";